<template>
  <date-picker :model-value="props.date"
               locale="ko"
               format="yyyy-MM-dd"
               model-type="yyyyMMdd"
               :enable-time-picker="false"
               :min-date="minDate"
               :max-date="maxDate"
               :clearable="props.isClear"
               auto-apply
               @update:model-value="cal_selectDate"
               week-start="0"
               year-first
               prevent-min-max-navigation
               :disabled="props.disabled"
               :teleport="true">
  </date-picker>
</template>

<script setup>
import DatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import {computed, defineProps, defineEmits} from "vue";

import {getUtils} from "@/utils/import";
const {$cmmn} = getUtils();

const props = defineProps({
  date: String,
  min: {
    type: String,
    default: '19500101'
  },
  max: {
    type: String,
    default: '20991231'
  },
  disabled: {
    type: Boolean,
    default: false
  },
  isClear: {
    type: Boolean,
    default: false
  },
})

const minDate = computed(() => $cmmn.date.getYmdFormat(props.min, '-'));
const maxDate = computed(() => $cmmn.date.getYmdFormat(props.max, '-'));

const emits = defineEmits(['select']);

const cal_selectDate = (date) => {
  emits('select', date ?? '');
};

</script>

<style scoped>

</style>
